<template>
  <v-app>
    <div class="container">
      <Header></Header>
      <Nav></Nav>
      <router-view id="contentWeb"></router-view>
      <Footer></Footer>
    </div>
  </v-app>
</template>

<script>
import Header from "./layouts/Header.vue";
import Nav from "./layouts/Nav.vue";
import Footer from "./layouts/Footer.vue";
import $ from "jquery";
export default {
  name: "App",

  components: {
    Header,
    Nav,
    Footer,
  },

  data: () => ({
    //
  }),
  mounted() {
    function killCopy() {
      return false;
    }
    function reEnable() {
      return true;
    }
    document.onselectstart = new Function("return false");
    if (window.sidebar) {
      document.onmousedown = killCopy;
      document.onclick = reEnable;
    }

    $(document).on("contextmenu", function (e) {
      e.preventDefault();
    });

    $(document).keydown(function (event) {
      if (event.keyCode == 123) {
        // Prevent F12
        return false;
      } else if (event.ctrlKey && event.shiftKey && event.keyCode == 73) {
        // Prevent Ctrl+Shift+I
        return false;
      }
    });

    // function click(e) {
    //   if (document.all) {
    //     if (event.button == 2 || event.button == 3) {
    //       alert(
    //         "Please contact the source center! Thank you for your cooperation!!!"
    //       );
    //       oncontextmenu = "return false";
    //     }
    //   }
    //   if (document.layers) {
    //     if (e.which == 3) {
    //       oncontextmenu = "return false";
    //     }
    //   }
    // }
    // if (document.layers) {
    //   document.captureEvents(Event.MOUSEDOWN);
    // }
    // document.onmousedown = click;
    // document.oncontextmenu = new Function("return false;");

    // document.onkeydown =
    //   document.onkeyup =
    //   document.onkeypress =
    //     function () {
    //       if (window.event.keyCode == 123) {
    //         window.event.returnValue = false;
    //         return false;
    //       }
    //     };
  },
};
</script>

<style lang="scss">
@import url("assets/css/all.min.css");
.theme--light.v-application {
  background-color: #f5f5f5 !important;
}
.v-application--wrap > .container {
  padding-top: 0;
}
table {
  background-color: #ffff;
}
// #app {
//   background-image: url("./assets/img/anh-truong-rang-co.jpg");
//   background-size: cover;
//   background-repeat: no-repeat;
//   background-position: right center;
//   background-attachment: fixed;
// }
// #contentWeb {
//   padding-bottom: 50px;
// }
</style>
